module.exports = __webpack_public_path__ + "static/media/Harrison.1ae62568.jpg";